<ng-template>
  <ng-container *transloco="let t; prefix: 'mobile-pop-up'">
    <div [dir]="direction$ | async" aria-labelledby="title" role="dialog" class="pop-up-content">
      @if (headerTemplate()) {
        <ng-container
          [ngTemplateOutlet]="headerTemplate()"
          [ngTemplateOutletContext]="{ $implicit: t('close_dialog') }">
        </ng-container>
      } @else {
        <div class="header">
          <h3 id="title">{{ title() }}</h3>

          @if (ignoreTheming()) {
            <button
              accredible-button-flat
              icon="close"
              [attr.aria-label]="t('close_dialog')"
              (click)="closeMenu()"></button>
          } @else {
            <button mat-icon-button [attr.aria-label]="t('close_dialog')" (click)="closeMenu()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      }
      <ng-content />
    </div>
  </ng-container>
</ng-template>
